// extracted by mini-css-extract-plugin
export var button = "_oc-0";